import styled from 'styled-components';

export const BannerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-image: url(${(props) => props.imageSrcDesktop});
  background-size: cover;
  background-position: center;
  border-radius: 21px;
  overflow: hidden;
  height: 50vh;
  width: 95%;
  margin: auto;
  position: relative;

  @media (max-width: 768px) {
    padding: 10px;
    border-radius: 21px;
    display: flex;
    flex-direction: column;
    background-image: url(${(props) => props.imageSrcMobile});
    align-items: center;
    height: 90vh;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  z-index: 1;
`;

export const TextImage = styled.img`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  max-width: 220px;
  width: 100%;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 10px;
  }
`;

export const Content = styled.div`
  position: relative;
  z-index: 2;
  color: white;
  text-align: center;
  padding: 20px;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;

  @media (max-width: 768px) {
    padding: 10px;
    border-radius: 0;
    width: 90%;
  }
`;

export const Title = styled.h1`
  font-size: 2em;
  margin-bottom: 10px;
  color: #fcfaee;
  font-weight: bold;

  b {
    color: #006acb;
  }
  @media (max-width: 768px) {
    font-size: 1.5em;
  }
`;

export const Subtitle = styled.p`
  font-size: 1.2em;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 21px;
    margin-bottom: 10px;
  }
`;

export const BtnMobile = styled.div`
  display: block;

  @media (max-width: 768px) {
    display: none;
    width: 100%;
  }
`;
export const Button = styled.button`
  padding: 10px 20px;
  font-size: 1em;
  color: white;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }

  @media (max-width: 768px) {
    padding: 8px 16px;
    font-size: 0.9em;
  }
`;
